import axios from "axios"

axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3000/v1/'

if (localStorage.getItem('token'))
    global.setAxiosAuthToken(localStorage.getItem('token'))